/**
 * Governance Hub header — page title, subtitle, view tabs.
 * Filters moved to FilterBar for cleaner layout.
 */
import React from 'react';

export default function GovernanceHubHeader({
  viewMode,
  setViewMode,
  showStateContracts = false,
}) {
  return (
    <header className="bg-white rounded-2xl shadow-sm border border-slate-200/80 overflow-hidden">
      <div className="p-6 pb-4">
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
          <div>
            <h1 className="text-2xl font-bold text-slate-800 tracking-tight">Governance Hub</h1>
            <p className="text-slate-500 text-sm mt-0.5">
              Medicare and Medicaid obligations and deadlines, in one place.
            </p>
          </div>
        </div>
      </div>
      <div className="px-6 pb-4">
        <div className="flex rounded-xl bg-slate-100/80 p-1 border border-slate-200/80 w-fit" role="tablist" aria-label="View mode">
          {[
            // Operator decision 2026-07-21: obligations only — Board and
            // Insights tabs hidden (not removed) alongside the memo/CAP feed.
            { id: 'agenda', label: 'Obligations' },
            { id: 'calendar', label: 'Calendar' },
            ...(showStateContracts ? [{ id: 'correspondence', label: 'Correspondence' }] : []),
            // { id: 'board', label: 'Board' },
            // { id: 'insights', label: 'Insights' },
            // Compliance-only: the SMAC register (State Medicaid contracts).
            ...(showStateContracts ? [{ id: 'state-contracts', label: 'State Contracts' }] : []),
          ].map((tab) => (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={viewMode === tab.id}
              onClick={() => setViewMode(tab.id)}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-indigo-400 ${
                viewMode === tab.id ? 'bg-white text-slate-800 shadow-sm border border-slate-200/80' : 'text-slate-600 hover:text-slate-800'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>
    </header>
  );
}
